module.exports = "/_next/static/images/ImplementationOptions@2x-2e793642d88685080d46c10ca276fe38.webp";